import { Navigate, Route, Routes, useParams } from 'react-router-dom'
import Page from '../../components/layouts/page'
import { useQuery } from '@tanstack/react-query'
import Details from './details'
import ActivityLogsTable from '../../components/activity_logs_table'

const User = () => {
  const userID = useParams().userID
  const { data: user } = useQuery([`users/`, `${userID}`])
  return (
    <Page
      breadcrumbs={[{ text: 'Users', to: '/settings/users' }, { text: user?.name }]}
      tabs={[
        { name: 'Details', to: `details` },
        { name: 'Activity Logs', to: `activity-logs` },
      ]}
    >
      <Routes>
        <Route path='/details' element={<Details />} />
        <Route path='activity-logs' element={<ActivityLogsTable queryKey={`causerID=${user?.id}`} />} />
        <Route path='*' element={<Navigate to={`details`} replace={true} />} />
      </Routes>
    </Page>
  )
}

export default User
